// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__VLNmt","loader-track":"Loader_loader-track__u1PhY","spin":"Loader_spin__qwBYk","loader-container":"Loader_loader-container__vLFGd"};